import { Config } from "config";

export default {
  basePath: process.env.BASE_PATH ? `${process.env.BASE_PATH}/` : '/site/',
  basename: '/site',
  routerPath: '/*',
  env: 'stg',
  api: {
    url: '/bff',
    jwt: 'authorization',
    app: 'APP'
  }
} as Config
